export function useTime() {
  const currentTime = ref(useDateFormat(useNow(), 'HH:mm:ss').value)
  const currentDayAsNumber = useDateFormat(useNow(), 'd')
  // Update currentTime every 60 seconds using useIntervalFn
  useIntervalFn(() => {
    currentTime.value = useDateFormat(useNow(), 'HH:mm:ss').value
  }, 60000) // 60000 ms = 1 minute

  return {
    currentTime,
    currentDayAsNumber,
  }
}
